export default __webpack_public_path__ + "static/media/15.f3dc5ae8.png";